import React from 'react';
import PropTypes from 'prop-types';
import SidebarDownloadDocButton from './SidebarDownloadDocButton';

const sidebarSectionContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 30,
  paddingRight: 30,
  paddingTop: 25,
  paddingBottom: 25,
};

const headerStyle = {
  margin: 0,
};

const SidebarDownloadSection = props => (
  <div
    className="rank-brain-2-sidebar-section-container section-container"
    style={sidebarSectionContainerStyle}
  >
    <SidebarDownloadDocButton
      slug={props.slug}
      imgSrc="/images/rank-brain-2/download-word-2x.png"
      imgSrcHover="/images/rank-brain-2/download-word-hover-2x.png"
      text="Word"
      format="docx"
    />
    <SidebarDownloadDocButton
      slug={props.slug}
      imgSrc="/images/rank-brain-2/download-pdf-2x.png"
      imgSrcHover="/images/rank-brain-2/download-pdf-hover-2x.png"
      text="PDF"
      format="pdf"
    />
    <h3 style={headerStyle}>
      Free Download
    </h3>
  </div>
);

export default SidebarDownloadSection;

SidebarDownloadSection.propTypes = {
  slug: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/SidebarDownloadSection/index.jsx